import React, { useEffect, createElement } from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { SalesCopy } from './components/SalesCopy';
import { BonusSection } from './components/BonusSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PricingSection } from './components/PricingSection';
import { SocialProofPopup } from './components/SocialProofPopup';
import { ArrowRightIcon } from 'lucide-react';
export function App() {
  // Meta Pixel
  useEffect(() => {
    if (typeof window !== 'undefined' && !(window as any).fbq) {
      const f = window as any;
      const n = f.fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      f.fbq('init', '937331855399019');
      f.fbq('track', 'PageView');
    }
  }, []);
  return <div className="min-h-screen bg-[#1a1040]" data-id="element-0">
      {/* Sticky Navigation */}
      <Navbar data-id="element-1" />

      {/* Hero Section */}
      <HeroSection data-id="element-2" />

      {/* Sales Copy Sections */}
      <SalesCopy data-id="element-3" />

      {/* Bonus Section - Before Pricing */}
      <BonusSection data-id="element-4" />

      {/* Pricing Section */}
      <PricingSection data-id="element-5" />

      {/* Testimonials - After Pricing */}
      <TestimonialsSection data-id="element-6" />

      {/* Final CTA Banner */}
      <section className="relative z-10 bg-gradient-to-b from-[#241550] to-[#1a1040] py-16 md:py-24 px-4" data-id="element-7">
        <div className="max-w-3xl mx-auto text-center" data-id="element-8">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-white italic mb-8" data-id="element-9">
            Hacé clic y empezá hoy.
          </h2>
          <a href="#comprar" className="inline-flex items-center gap-3 bg-white text-[#0f0a1e] font-bold text-lg md:text-xl px-10 py-4 rounded-full hover:bg-white/90 transition-all duration-300 shadow-lg" data-id="element-10">
            ACCEDER AHORA <ArrowRightIcon className="w-5 h-5" data-id="element-11" />
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#130d30] py-8 px-4" data-id="element-12">
        <div className="max-w-4xl mx-auto" data-id="element-13">
          <div className="border-t border-white/10 pt-6 text-center" data-id="element-14">
            <p className="text-white/50 text-sm" data-id="element-15">
              © 2026 Sistema Pro Cartas Natales. Todos los derechos reservados.
            </p>
          </div>
        </div>
      </footer>

      {/* Social Proof Popup */}
      <SocialProofPopup data-id="element-16" />
    </div>;
}